import { useEffect, useState } from "react"

/**
 * Возвращает оставшееся количество секунд для турнира и раз в секунду
 * уменьшает его до нуля.
 *
 * Источник времени: tournament.starts_in (до старта) либо tournament.time_left
 * (турнир идёт). Значение пересчитывается при изменении этих полей.
 *
 * @param {object} tournament - Объект турнира.
 * @returns {number} Оставшиеся секунды (не меньше 0).
 */
export const useCountdown = (tournament) => {
  const getInitialSeconds = () =>
    Number(tournament?.starts_in ?? tournament?.time_left ?? 0)

  const [remainingSeconds, setRemainingSeconds] = useState(getInitialSeconds)

  useEffect(() => {
    setRemainingSeconds(getInitialSeconds())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tournament?.starts_in, tournament?.time_left])

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingSeconds((prevSeconds) =>
        prevSeconds <= 0 ? 0 : prevSeconds - 1,
      )
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return remainingSeconds
}
